import dayjsTZ from "../../../../utils/dayjs";
import { store } from "../../../../store";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
  round2,
} from "../reportResult";

/**
 * Open / forgotten shifts in the selected period.
 * Rows: still-open clockings + closed with forgotClockOut flag.
 */
export const openForgottenShifts = (
  _prev,
  filter,
  columns,
  manualColumns,
  employees,
) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const data = store?.getState()?.customReducer?.reportClockings || [];
  const { startTs, endTs } = intervalBounds(filter);
  const empById = new Map(
    (employees || []).map((e) => [e.employeeId, e]),
  );

  const preFilter = data
    .filter((d) => {
      if (!d?.clockInDate) return false;
      if (d.clockInDate < startTs || d.clockInDate > endTs) return false;
      if (filter?.employeeId && d.employeeId !== filter.employeeId) return false;
      const open = d.clockOutDate == null || d.clockOutDate === "";
      const forgot = !!d.forgotClockOut;
      return open || forgot;
    })
    .map((d) => {
      const emp = d.employeeDetails || empById.get(d.employeeId) || {};
      const open = d.clockOutDate == null || d.clockOutDate === "";
      const ageHours = open
        ? round2(
            dayjsTZ().diff(dayjsTZ(d.clockInDate), "hours", true),
          )
        : round2(
            dayjsTZ(d.clockOutDate).diff(
              dayjsTZ(d.clockInDate),
              "hours",
              true,
            ),
          );
      return {
        ...emp,
        employee: employeeFullName(emp) || d.employeeFullName || "",
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        clockDate: dayjsTZ(d.clockInDate).format("DD/MM/YYYY"),
        clockInDate: dayjsTZ(d.clockInDate).format("HH:mm"),
        clockOutDate: open
          ? "Hapur"
          : dayjsTZ(d.clockOutDate).format("HH:mm"),
        shiftStatus: open ? "Hapur" : "Mbyllur (harrova)",
        forgotClockOut: d.forgotClockOut ? "Po" : "Jo",
        ageHours,
        approved: d.approved ? "Aprovuar" : "Pa Aprovuar",
        clockInNote: d.clockInNote || "",
      };
    })
    .sort((a, b) =>
      String(a.employee).localeCompare(String(b.employee), "sq"),
    );

  return buildReportResult(preFilter, columns, manualColumns);
};
